import React from 'react';
import img from '../../../images/logo.png'
import { NavLink } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';

const Navigation = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark shadow-lg py-4  sticky">
                <div className="container">
                    {/* <a className="nav-link fw-bold text-decoration-none text-light fs-3" href="/"><img src={img} className='img-fluid w-100 text-left' alt="" /></a> */}
                    <NavLink to="/" className="fw-bold text-decoration-none text-dark"><img src={img} className='img-fluid' alt="" /></NavLink>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavHashLink to="/home/#" className="nav-link mx-3 text-light" style={{ textDecoration: 'none', color: 'white' }}>Home</NavHashLink>
                            </li>
                            <li className="nav-item">
                                <NavHashLink to="/home/#about" className="nav-link mx-3 text-light" style={{ textDecoration: 'none', color: 'white' }}>About</NavHashLink>
                            </li>
                            <li className="nav-item">
                                <NavHashLink to="/home/#projects" className="nav-link mx-3 text-light" style={{ textDecoration: 'none', color: 'white' }}>Projects</NavHashLink>
                            </li>
                            <li className="nav-item">
                                <NavHashLink to="/home/#blogs" className="nav-link mx-3 text-light" style={{ textDecoration: 'none', color: 'white' }}>Blogs</NavHashLink>
                            </li>
                        </ul>
                        <NavHashLink to="/home/#contact"><button className="btn btn-outline-success rounded-pill px-4">Contact Me</button></NavHashLink>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navigation;